import { appConfig } from '../../request/app.config';
import {
  DEFAULT_NETWORK_REQ_OPTIONS,
  NETWORK_REQ_OPTIONS_WITH_TOAST
} from '../../request/constants/request-options';
import { courierService } from '../../request/services/courier.service';
import { ListMetaNetworkParams } from '../../list-conductor/list-meta-data';
import { NetworkRequestOptions } from '../../request/interfaces/request-options';

import { ObjectsSelectionUpdatesPayload } from '../ObjectsConfiguration/interfaces/object-header';
import { FieldsSelectionUpdatesPayload } from '../ObjectsConfiguration/interfaces/object-field';

export const ObjectsConfigAPI = {
  objectsURL: `${appConfig.getObjectsURL()}`,

  getObjectConfigHeader(sourceType: string) {
    const requestUrl = `${this.objectsURL}/${sourceType}/column-template`;

    return courierService.get(requestUrl, DEFAULT_NETWORK_REQ_OPTIONS);
  },

  getFieldsMetadata(integrationId: number) {
    const requestUrl = `${this.objectsURL}/${integrationId}/fields/column-template`;

    return courierService.get(requestUrl, DEFAULT_NETWORK_REQ_OPTIONS);
  },

  getObjectsConfigStatus(integrationId: number) {
    const requestUrl = `${this.objectsURL}/${integrationId}/status`;

    return courierService.get(requestUrl, DEFAULT_NETWORK_REQ_OPTIONS);
  },

  restartObject(objectId: string, integrationId: number) {
    const requestUrl = `${this.objectsURL}/${integrationId}/${objectId}/actions/truncate-and-load`;

    return courierService.put(requestUrl, {}, DEFAULT_NETWORK_REQ_OPTIONS);
  },

  getObjectsConfig(listParams: ListMetaNetworkParams | undefined, integrationId: number) {
    const params = { ...(listParams || {}) };

    let filters: unknown[] = [];

    if ('filters' in params) {
      filters = [...(params.filters as Array<unknown>)];
      delete params.filters;
    }

    const options: NetworkRequestOptions = {
      ...DEFAULT_NETWORK_REQ_OPTIONS,
      networkOptions: {
        params
      }
    };

    return courierService.post(`${this.objectsURL}/${integrationId}/edit`, { filters }, options);
  },

  getObjectsConfigForView(listParams: ListMetaNetworkParams | undefined, integrationId: number) {
    const params = { ...(listParams || {}) };

    let filters: unknown[] = [];

    if ('filters' in params) {
      filters = [...(params.filters as Array<unknown>)];
      delete params.filters;
    }

    const options: NetworkRequestOptions = {
      ...DEFAULT_NETWORK_REQ_OPTIONS,
      networkOptions: {
        params
      }
    };

    return courierService.post(`${this.objectsURL}/${integrationId}`, { filters }, options);
  },

  saveObjectSelection(param: ObjectsSelectionUpdatesPayload, integrationId: number) {
    const filters = [];
    let body: ObjectsSelectionUpdatesPayload & {
      filters?: {
        operator: string;
        values: string[];
      }[];
    } = { ...param };

    if (body.search_key) {
      filters.push({
        operator: 'SEARCH_CASE_INSENSITIVE',
        values: [body.search_key]
      });

      delete body.search_key;

      body = { ...body, filters };
    }

    const requestUrl = `${this.objectsURL}/${integrationId}/edit`;

    return courierService.put(requestUrl, body, NETWORK_REQ_OPTIONS_WITH_TOAST);
  },

  getObjectFields(integrationId: number, objectId: string, loadMode: string) {
    const requestUrl = `${this.objectsURL}/${integrationId}/${objectId}/edit`;

    return courierService.post(
      requestUrl,
      {
        load_mode: loadMode
      },
      DEFAULT_NETWORK_REQ_OPTIONS
    );
  },

  getObjectFieldsForView(integrationId: number, objectId: string) {
    const requestUrl = `${this.objectsURL}/${integrationId}/${objectId}`;

    return courierService.get(requestUrl, DEFAULT_NETWORK_REQ_OPTIONS);
  },

  saveFieldsSelection(
    param: FieldsSelectionUpdatesPayload,
    integrationId: number,
    objectId: string
  ) {
    const requestUrl = `${this.objectsURL}/${integrationId}/${objectId}/edit`;

    return courierService.put(requestUrl, param, NETWORK_REQ_OPTIONS_WITH_TOAST);
  }
};
